import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import "datatables.net";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import ProductKitSummary from "interfaces/ProductKitSummary";
import * as $ from "jquery";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import getBaseUrl from "utils/getBaseUrl";
import ContentLoading from "components/common/ContentLoading";

interface State {
    data: ProductKitSummary[];
    spinner: boolean;
}

export default class Index extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Kits</BreadcrumbLink>
                    </Breadcrumb>

                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">Kits</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/kits/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    ref={this.mainDataTableRef}
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "20%" }}>ID</th>
                                            <th style={{ width: "20%" }}>Code</th>
                                            <th style={{ width: "30%" }}>Description</th>
                                            <th style={{ width: "30%" }}>Item Number</th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}
                                                    id={`row-${item.id}`}
                                                >
                                                    <td>{item.id}</td>
                                                    <td>
                                                        {item.code}
                                                    </td>
                                                    <td>{item.description}</td>
                                                    <td>{item.number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        document.title = "Kits - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "code",
            "description",
            "number",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<ProductKitSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    //private handleDataTableDraw(dataTable: any) {
    //    $(dataTable)
    //        .find("a:not([href='#'])")
    //        .click((e) => {
    //            e.preventDefault();
    //            this.props.history.push($(e.currentTarget).attr("href")!);
    //        });
    //    $(dataTable)
    //        .find(".btn-delete")
    //        .click((e) => {
    //            e.preventDefault();
    //            this.deleteProduct(parseInt($(e.currentTarget).attr("data-id")!, 10));
    //        });
    //}

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer");

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim(); 
            if (rowId) {
                this.props.history.push(`/kits/${rowId}`);
            }
        });

    }

    //private async deleteProduct(id: number) {
    //    let response = await apifetch(
    //        `products/${id}`,
    //        {
    //            method: "DELETE",
    //        },
    //        true
    //    );
    //    if (response.ok) {
    //        this.mainDataTableRef.current!.reload();
    //    }
    //}
}



// WEBPACK FOOTER //
// ./ClientApp/components/kits/Index.tsx